import {
	GET_SAMPLE_ITEM_TAGS,
	GET_SAMPLE_ITEM_TAG_GROUPS,
	CREATE_TAG,
	DELETE_SAMPLE_TAG,
	UPDATE_TAG_GROUP,
	DELETE_SAMPLE_TAG_GROUP
} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {normalize, isApiResponseOk, normalizedDelete} from '../../util/utils';

const tagsreducer = (state = initialstate.tagItems, action) => {
	switch (action.type) {
		case GET_SAMPLE_ITEM_TAGS:
			if (isApiResponseOk(action)) {
					const newData = {
						...state,
						tags: action.response.data.length > 0 ?
							normalize(action.response.data, 'engagementTagId', state.tags, undefined, true)
							: {...normalize()}
					};
					return {
						...newData,
						tags: {
							...newData.tags,
							page: action.response.page,
							pages: action.response.pages
						}
					};				
			}
			return state;
		case GET_SAMPLE_ITEM_TAG_GROUPS:
			if (isApiResponseOk(action)) {
				return {...state, tagGroups: normalize(action.response, 'tagGroupGuid', state.tagGroups, undefined, true)};
			}
			return state;
		case CREATE_TAG:
			if (isApiResponseOk(action)) {
				const tagDetails = {
					engagementTagGroupId: action.tagData.engagementTagGroupId,
					engagementTagName: action.tagData.name,
					engagementTagGroupName: action.tagData.tagGroupName,
					colorCode: action.tagData.colorCode,
					entityCount: 0,
					entityID: action.tagData.entityId,
					id: action.response.tagId
				};
				return {
					...state,
					tags: {
						...state.tags,
						byId: {
							...state.tags.byId,
							[action.response.tagId]: tagDetails
						},
						allIds: [...state.tags.allIds, action.response.tagId]
					}
				};
			}
			return state;
		case DELETE_SAMPLE_TAG:
			if (isApiResponseOk(action)) {
				return {
					...state,
					tags: normalizedDelete(state.tags, action.tagId)
				};
			}
			return state;
		case DELETE_SAMPLE_TAG_GROUP:
			if (isApiResponseOk(action)) {
				const tagGroupGuid = Object.values(state.tagGroups.byId).find(
					(tagGroup) => tagGroup.tagGroupId === action.tagGroupId
				).id;
				return {
					...state,
					tagGroups: normalizedDelete(state.tagGroups, tagGroupGuid)
				};
			}
			return state;
		case UPDATE_TAG_GROUP:
			if (isApiResponseOk(action)) {
				const tagGroupGuid = Object.values(state.tagGroups.byId).find(
					(tagGroup) => tagGroup.tagGroupId == action.response.tagGroupId
				).id;
				return {
					...state,
					tagGroups: {
						...state.tagGroups,
						[tagGroupGuid]: {
							...state.tagGroups[tagGroupGuid],
							...action.response
						}
					}
				};
			}
			return state;
		default:
			return state;
	}
};

export default tagsreducer;
